import Vue from 'vue'
import { AxiosError, AxiosResponse } from 'axios'

const contactRelations = ['function', 'customers', 'tags', 'custom_fields']

const needFetchContact = (contact: KwixeoCustomers.Contact|KwixeoCustomers.ContactForm): boolean => {
  return !contactRelations.every(relation => relation in contact)
}

const fetchContact = async (id: number|string): Promise<KwixeoCustomers.Contact> => {
  return await Vue.prototype.$kwCustomers.axios.get('/customer/contact/' + id, {
      params: {
        include: contactRelations.join(',')
      }
    })
    .then((response: AxiosResponse) => {
      return response.data
    })
    .catch((error: AxiosError) => {
      throw new Error((error.response as AxiosResponse)?.data)
    })
}

export {
  contactRelations, needFetchContact, fetchContact
}
